import React from 'react';
import { GraduationCap, Code, Trophy, Target, MapPin, Award } from 'lucide-react';
import './FootballTimeline.css';

const FootballTimeline = () => {
  const journey = [
    {
      position: 'goalkeeper',
      year: '2023',
      title: 'Début Licence Informatique',
      description: 'Entrée à l\'Université de Caen - Fondamentaux',
      icon: <GraduationCap size={24} />,
    },
    {
      position: 'defender',
      year: '2024',
      title: 'Premiers Projets',
      description: 'Java, Python, POO - Consolidation des bases',
      icon: <Code size={24} />,
    },
    {
      position: 'midfielder',
      year: '2025',
      title: 'Licence en cours',
      description: 'Mini site SCRUD, POO, BDD',
      icon: <Trophy size={24} />,
    },
    {
      position: 'striker',
      year: '2026',
      title: 'Etude Ingénieur Informatique',
      description: 'Cybersécurité & Innovations',
      icon: <Target size={24} />,
    },
  ];

  return (
    <div className="football-timeline">
      <h3 className="timeline-title">
        <Trophy className="title-icon" />
        Mon Parcours
      </h3>
      
      <div className="timeline-wrapper">
        {/* Left side - Start */}
        <div className="timeline-side left-side">
          <div className="side-icon">
            <MapPin size={32} />
          </div>
          <h4 className="side-title">DÉBUT</h4>
          <p className="side-desc">
            Licence Informatique<br />
            Université de Caen
          </p>
          <div className="side-badge">2023</div>
        </div>

        {/* Football Field */}
        <div className="football-field">
          {/* Field lines */}
          <div className="field-line center-line"></div>
          <div className="field-line penalty-area left"></div>
          <div className="field-line penalty-area right"></div>
          <div className="center-circle"></div>
          
          {/* Journey positions */}
          {journey.map((item, index) => (
            <div key={index} className={`position-marker ${item.position}`}>
              <div className="marker-ball">
                {item.icon}
              </div>
              <div className="marker-info">
                <div className="marker-year">{item.year}</div>
                <div className="marker-title">{item.title}</div>
                <div className="marker-desc">{item.description}</div>
              </div>
              {index < journey.length - 1 && (
                <div className="pass-line"></div>
              )}
            </div>
          ))}
        </div>

        {/* Right side - Goal */}
        <div className="timeline-side right-side">
          <div className="side-icon goal-icon">
            <Award size={32} />
          </div>
          <h4 className="side-title">OBJECTIF</h4>
          <p className="side-desc">
            Ingénieur Informatique<br />
          </p>
          <div className="side-badge goal-badge">🎯</div>
        </div>
      </div>
    </div>
  );
};

export default FootballTimeline;
